import axios from '../utils/axios';

export function getUnmappedActiveRecruitersCount(adminId, params) {
    return axios.get(`/admin/${adminId}/unmapped-active-recruiters-count`, { params });
}
